<template>
        <undecorated-link   :href="href === false ? null : href"
                            :class="baseClass + colorClass"
                            @click="$emit('click', $event)"
        >
            <slot></slot>
        </undecorated-link>
</template>

<script>

import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link";

export default {
    name: "SonicuButton",
    mixins: [],
    emits: ['click'],
    components: {UndecoratedLink},
    props: {
        href: {
            type: [String, Boolean],
            default: false,
        },
        bgColor: {
            type: String,
            default: 'bg-blue-600'
        },
        bgColorHover: {
            type: String,
            default: 'bg-blue-500'
        },
        bgColorFocus: {
            type: String,
            default: 'bg-blue-500',
        },
        bgColorActive: {
            type: String,
            default: 'bg-blue-600',
        },
        textColor: {
            type: String,
            default: 'text-white',
        },
        textColorHover: {
            type: String,
            default: 'text-white',
        },
        textColorFocus: {
            type: String,
            default: 'text-white',
        },
        textColorActive: {
            type: String,
            default: 'text-white',
        },
        borderColor: {
            type: String,
            default: 'border-transparent',
        },
        borderColorFocus: {
            type: String,
            default: 'border-blue-700',
        },
        borderColorHover: {
            type: String,
            default: 'border-transparent',
        },
        borderColorActive: {
            type: String,
            default: 'border-transparent',
        },
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        buttonClick() {
            this.$emit('click')
        },
    },
    computed: {
        colorClass() {
            return ` ${this.bgColor} hover:${this.bgColorHover} focus:${this.bgColorFocus} active:${this.bgColorActive}
                    ${this.textColor} hover:${this.textColorHover} focus:${this.textColorFocus} active:${this.textColorActive}
                    ${this.borderColor} hover:${this.borderColorHover} focus:${this.borderColorFocus} active:${this.borderColorActive}`
        },
        baseClass() {
            return ` relative inline-flex items-center px-4 py-2 border text-sm leading-5 font-medium
                    rounded-md w-full flex justify-center items-center`
        },
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>